import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { PowerSelectTriggerSignature } from 'ember-power-select/components/power-select/trigger';
import type { Select } from 'ember-power-select/components/power-select-multiple';

import type {
  Group,
  Option,
} from '../../../../types/components/prism/combo-select-input.ts';
import PrismIcon from '../../icon.gts';
import PrismIconFlag from '../../icon-flag.gts';

interface PrismComboSelectInputUnsafeMultipleSelectionImmediateTriggerSignature {
  Args: PowerSelectTriggerSignature<Option, Group<Option>>['Args'];
}

export default class PrismComboSelectInputUnsafeMultipleSelectionImmediateTrigger extends Component<PrismComboSelectInputUnsafeMultipleSelectionImmediateTriggerSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  stopPropagation = (event: Event) => event.stopPropagation();

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get select() {
    return this.args.select as Select<Option, Group<Option>>;
  }

  @action
  handleOptionRemoveClick(option: Option, event: MouseEvent): void {
    event.stopPropagation();
    const { selected: options } = this.select;
    const newOptions = options.filter((o) => o !== option);
    this.select.actions.select(newOptions);
  }

  <template>
    {{! template-lint-disable no-pointer-down-event-binding }}
    <div class="unsafe-multiple-selection-immediate-trigger">
      {{#if this.select.selected.length}}
        {{#each this.select.selected as |option|}}
          <div class="unsafe-multiple-selection-immediate-trigger__container">
            {{#if option.iconFlag}}
              <PrismIconFlag @code={{option.iconFlag}} />
            {{/if}}
            <p
              class="text-300--medium unsafe-multiple-selection-immediate-trigger__label"
            >
              {{option.label}}
            </p>
            <button
              class="prism-button--unstyled unsafe-multiple-selection-immediate-trigger__remove-button"
              type="button"
              {{on "click" (fn this.handleOptionRemoveClick option)}}
              {{on "mousedown" this.stopPropagation}}
            >
              <PrismIcon @color="inherit" @name="cross" @size="small" />
            </button>
          </div>
        {{/each}}
      {{else}}
        <p
          class="text-300--medium unsafe-multiple-selection-immediate-trigger__placeholder"
        >
          {{@placeholder}}
        </p>
      {{/if}}
    </div>
    <PrismIcon @name="chevron-down" @size="small" />
  </template>
}
